import React from 'react';
import Button from './ui/Button';
import GameIcons from '../components/ui/GameIcons';

const GameCard = ({ game, onClick }) => {
  const GameIcon = GameIcons[game.id];
  
  return (
    <div className="bg-white/10 backdrop-blur-lg border border-white/20 rounded-lg shadow-md overflow-hidden hover:bg-white/20 transition-all duration-300">
      <div className="w-full h-48 flex items-center justify-center p-4 bg-gradient-to-b from-white/5 to-transparent">
        {GameIcon && (
          <div className="w-32 h-32">
            <GameIcon />
          </div>
        )}
      </div>
      <div className="p-4">
        <h3 className="text-lg font-semibold mb-2 text-white">{game.title}</h3>
        <p className="text-gray-300 text-sm mb-4">{game.description}</p>
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-1">
            <span className="text-sm text-gray-400">
              Difficulty: {game.difficulty}
            </span>
            <span className="text-sm text-gray-400">
              Popularity: {game.popularity}
            </span>
          </div>
          <Button 
            onClick={onClick}
            className="bg-white/10 hover:bg-white/20 text-white"
          >
            Play Now
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GameCard;